import { NavLink, useLocation } from 'react-router-dom'
import type { HubBottomNavItem } from '../types'
import { isNavItemActive, spaTo } from '../lib/navActive'
import { prefetchHubNavKey } from '../lib/routeChunks'

const ICONS: Record<string, string> = {
  home: '⌂',
  'user-plus': '+',
  'git-branch': '⑂',
  megaphone: '📢',
  'user-circle': '👤',
  star: '★',
}

type Props = {
  items: HubBottomNavItem[]
}

export function BottomNav({ items }: Props) {
  const location = useLocation()

  return (
    <nav className="bp-bottom-nav" aria-label="Navegação principal">
      {items.map((item) => {
        const tone = `nav-${item.key}`
        if (item.spa) {
          return (
            <NavLink
              key={item.key}
              to={spaTo(item.key)}
              onPointerEnter={() => prefetchHubNavKey(item.key)}
              onFocus={() => prefetchHubNavKey(item.key)}
              className={({ isActive }) =>
                [
                  tone,
                  isNavItemActive(item.key, location.pathname, isActive) ? 'active' : '',
                  item.cta ? 'cta' : '',
                ]
                  .filter(Boolean)
                  .join(' ')
              }
            >
              <span className="icon" aria-hidden>
                {ICONS[item.icon] || '•'}
              </span>
              {item.label}
            </NavLink>
          )
        }

        return (
          <a
            key={item.key}
            href={item.href}
            className={[tone, item.cta ? 'cta' : ''].filter(Boolean).join(' ')}
          >
            <span className="icon" aria-hidden>
              {ICONS[item.icon] || '•'}
            </span>
            {item.label}
          </a>
        )
      })}
    </nav>
  )
}
